<template>
  <div class="">
      <br />
      <v-card>

        <v-card-title primary-title>
            You will receive email describing your Kid's Marketplace activities &nbsp; <b>{{mailFrequency}}.</b>
            You will always be copied (bcc) on emails sent from your kid's account or to your kid's account immediately.
        </v-card-title>

       <v-card-actions>
         <v-spacer></v-spacer>
          <v-btn @click="show = !show" flat color="accent">
            Change Setting
            <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>

          </v-btn>

        </v-card-actions>

        <v-slide-y-transition>

          <v-card-text v-show="show">
              <v-flex xs6 row>
                <v-select :loading="inprogress" @change="updateFrequency" :items="frequencies" v-model="frequency" label="Receive activity emails"></v-select>
              </v-flex>

              <div v-if="errMessage" class="error--text">
                {{ errMessage }}
              </div>
              <div v-if="success" class="heading success--text">
                Update completed successfully.
              </div>
          </v-card-text>
        </v-slide-y-transition>
      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
// import utils from '../../../utils.ts'
// import firebase from 'firebase/app'
import config from '../../../config.js'

export default {
  name: 'MailSettings',
  components: {
  },
  computed: {
    ...mapState({
      mailFrequency: state => state.parent.userInfo.mailFrequency
    })
  },
  data () {
    return {
      show: false,
      inprogress: false,
      success: false,
      errMessage: null,
      frequency: 'weekly',
      frequencies: ['daily', 'weekly', 'monthly', 'never']
    }
  },
  mounted: function () {
    this.frequency = this.mailFrequency
  },
  methods: {
    updateFrequency: async function () {
      this.errMessage = null
      this.inprogress = true
      this.success = false

      try {
        const updateParentMailFrequency = config.getFunctions().httpsCallable('updateParentMailFrequency')
        await updateParentMailFrequency({
          'frequency': this.frequency
        })
        this.success = true
      } catch (err) {
        console.error('Error updating mail freq: ' + JSON.stringify(err))
        this.errMessage = 'Error updating: ' + err
      }
      this.inprogress = false
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
